const template = [
  {
    path: '/template',
    component: () => import('@/page/template/Index.vue'),
    // redirect: '/template/Button',
    icon: 'icon-mood',
    children: [
      {
        path: '/template/button',
        component: () => import('@/page/template/Button.vue'),
        meta: {
          name: 'Button',
          isActive: false,
        },
      },
      {
        path: '/template/dialog',
        component: () => import('@/page/template/Dialog.vue'),
        meta: {
          name: 'Dialog',
          isActive: false,
        },
      },
      {
        path: '/template/etc',
        component: () => import('@/page/template/Etc.vue'),
        meta: {
          name: 'Etc',
          isActive: false,
        },
      },
      {
        path: '/template/form',
        component: () => import('@/page/template/Form.vue'),
        meta: {
          name: 'Form',
          isActive: false,
        },
      },
      {
        path: '/template/input',
        component: () => import('@/page/template/Input.vue'),
        meta: {
          name: 'Input',
          isActive: false,
        },
      },
      {
        path: '/template/layout',
        component: () => import('@/page/template/Layout.vue'),
        meta: {
          name: 'Layout',
          isActive: false,
        },
      },
      {
        path: '/template/table',
        component: () => import('@/page/template/Table.vue'),
        meta: {
          name: 'Table',
          isActive: false,
        },
      },
      {
        path: '/template/filter-table',
        component: () => import('@/page/template/FilterTable.vue'),
        meta: {
          name: 'FilterTable',
          isActive: false,
        },
      },
      {
        path: '/template/mail',
        component: () => import('@/page/template/Mail.vue'),
        meta: {
          name: 'Mail',
          isActive: false,
        },
      },
      {
        path: '/template/mail_css',
        component: () => import('@/page/template/MailCss.vue'),
        meta: {
          name: 'MailCss',
          isActive: false,
        },
      },
      {
        path: '/template/print',
        component: () => import('@/page/template/Print.vue'),
        meta: {
          name: 'Print',
          isActive: false,
        },
      },
    ],
    meta: {
      name: 'Template',
      isMenu: true,
    },
  },
];

export default template;
